import React, { FC } from 'react';
import styles from './Main.css';

export const CountrysideMain: FC<React.PropsWithChildren> = ({ children }) => (
  <div className={styles['main']}>{children}</div>
);
